import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetch = (doctor: any) => ({
    type: 'fetch_Doctor_success',
    payload: doctor,
});
export const fetchRegion = (patient: any) => ({
    type: 'fetch_Patient_success',
    payload: patient,
});

export const getPaymentsData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:'1'};
            const apiname = Admin_API.payments_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetch(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchRegionsData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:'1'};
            const apiname = Admin_API.payments_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchRegion(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

